import { useEffect } from 'react';

import { useAppDispatch } from '@hooks/redux';
import { setAppConfig } from '@store/appConfig/appConfigSlice';

interface IUsePlatformTheme {
  useInIframeOnly?: boolean;
}

export const usePlatformTheme = ({
  useInIframeOnly,
}: IUsePlatformTheme = {}) => {
  const dispatch = useAppDispatch();
  const isIframe = window.self !== window.top;

  useEffect(() => {
    const shouldUsePlatformTheme =
      (useInIframeOnly && isIframe) || !useInIframeOnly;

    if (shouldUsePlatformTheme) {
      dispatch(
        setAppConfig({ isPlatformTheme: true, presetColor: 'Platform' })
      );
    }

    return () => {
      dispatch(
        setAppConfig({ presetColor: 'default', isPlatformTheme: false })
      );
    };
  }, [dispatch, isIframe, useInIframeOnly]);
};
